import axios from "axios"
import { API_URL } from "../utils/ApiLinks"
import { handleSuccessResponse, handleErrorResponse } from "../utils/handleReponse"
import { CreateApartmentComplex, CreateApartmentForComplex, CreateApartmentService, CreateSingleApartment, CreateSpaceParking, UploadApartmentFile, UploadComplexFile } from "../types/propertyInventory/ApartmentComplex"
import { CreateTenant } from "../types/propertyInventory/Tenant"
import { CreateRentPayment } from "../types/propertyInventory/RentPayment"
import { RemoveTenantFromApartment } from "../types/propertyInventory/Apartment"

class PropertyInventoryService {

    getApartmentComplexesByOwnerId = async (ownerId: number) => {
        try {
            const response = await axios.get(`${API_URL}/PropertyInventory/apartment-complexes/${ownerId}`)
            if(response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    getApartmentsByComplexId = async (complexId: string) => {
        try {
            const response = await axios.get(`${API_URL}/PropertyInventory/apartments/${complexId}`)
            if(response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    createApartmentComplex = async (data: CreateApartmentComplex) => {
        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
            if (key === 'files' && Array.isArray(value)) {
            value.forEach((file) => {
                formData.append('Files', file);
            });
            } else {
            formData.append(capitalizedKey, value);
            }
        });
        try {
            const response = await axios.post(`${API_URL}/PropertyInventory/apartment-complex`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
            if(response.status === 201 || response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            console.log(error)
            return handleErrorResponse(error)
        }
    }

    createSingleApartment = async (data: CreateSingleApartment) => {
        try {
            const response = await axios.post(`${API_URL}/PropertyInventory/single-apartment`, data)
            if(response.status === 201 || response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }
    
    createApartmentForComplex = async (data: CreateApartmentForComplex) => {
        try {
            const formData = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

                if (key === 'files' && Array.isArray(value)) {
                    value.forEach((file) => {
                        formData.append('Files', file);
                    });
                } else if (key === 'apartmentServices' && Array.isArray(value)) {
                    formData.append('ApartmentServices', JSON.stringify(value));
                } else if (key === 'tenant' && typeof value === 'object' && value !== null) {
                    Object.entries(value).forEach(([tKey, tValue]) => {
                        formData.append(`Tenant[${capitalize(tKey)}]`, tValue as any);
                    });
                } else if (key === 'apartmentHistory' && typeof value === 'object' && value !== null) {
                    Object.entries(value).forEach(([hKey, hValue]) => {
                        formData.append(`ApartmentHistory[${capitalize(hKey)}]`, hValue as any);
                    });
                } else if (value !== undefined) {
                    formData.append(capitalize(key), value as any);
                }
            });
            const response = await axios.post(
                `${API_URL}/PropertyInventory/apartment-for-complex`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            if(response.status === 201 || response.status === 200) {
                return handleSuccessResponse(response)
            }else{
                console.log('Unexpected response status:', response.data);
                return handleErrorResponse(response)
            }
        } catch (error) {
            console.log(error)
            return handleErrorResponse(error)
        }
    }

    createTenant = async (data: CreateTenant) => {
        try {
            const response = await axios.post(`${API_URL}/PropertyInventory/tenant`, data)
            if(response.status === 201 || response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    createParkingSpace = async (data: CreateSpaceParking) => {
        try {
            const response = await axios.post(`${API_URL}/PropertyInventory/parking-space`, data)
            if(response.status === 201 || response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    createApartmentService = async (data: CreateApartmentService) => {
        try {
            const response = await axios.post(`${API_URL}/PropertyInventory/apartment-service`, data)
            if(response.status === 201 || response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    createUploadComplexFiles = async (data : UploadComplexFile) => {
        try {
            const formData = new FormData();
            data.files.forEach((file: File) => {
            formData.append('files', file);
            });
            const response = await axios.post(
            `${API_URL}/PropertyInventory/complex-files/${data.apartmentComplexId}`,
            formData,
            {
                headers: {
                "Content-Type": "multipart/form-data"
                }
            }
            );
            if(response.status === 201 || response.status === 200) {
            return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    createUploadApartmentFiles = async (data : UploadApartmentFile) => {
        try {
            const formData = new FormData();
            data.files.forEach((file: File) => {
            formData.append('files', file);
            });
            const response = await axios.post(
            `${API_URL}/PropertyInventory/apartment-files/${data.apartmentId}`,
            formData,
            {
                headers: {
                "Content-Type": "multipart/form-data"
                }
            }
            );
            if(response.status === 201 || response.status === 200) {
            return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    createRentPayment = async (data: CreateRentPayment) => {
        try {
            const formData = new FormData();
            Object.entries(data).forEach(([key, value]) => {
            const Keycapitalized = key.charAt(0).toUpperCase() + key.slice(1);
            formData.append(Keycapitalized, value as any);
            });
            const response = await axios.post(
            `${API_URL}/PropertyInventory/rent-payment`,
            formData,
            {
                headers: {
                "Content-Type": "multipart/form-data"
                }
            }
            );
            if (response.status === 201 || response.status === 200) {
            return handleSuccessResponse(response);
            }
        } catch (error) {
            return handleErrorResponse(error);
        }
    }

    getAllServicesTypes = async () => {
        try {
            const response = await axios.get(`${API_URL}/PropertyInventory/service-types`)
            if(response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    getParkingSpacesByComplexId = async (complexId: string) => {
        try {
            const response = await axios.get(`${API_URL}/PropertyInventory/parking-spaces/${complexId}`)
            if(response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }

    }

    getFloorsByComplexId = async (complexId: string) => {
        try {
            const response = await axios.get(`${API_URL}/PropertyInventory/floors/${complexId}`)
            if(response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }

    }

    getApartmentComplexById = async (complexId: string) => {
        try {
            const response = await axios.get(`${API_URL}/PropertyInventory/apartment-complex/${complexId}`)
            if(response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    getApartmentById = async (apartmentId: string) => {
        try {
            const response = await axios.get(`${API_URL}/PropertyInventory/apartment/${apartmentId}`)
            if(response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            return handleErrorResponse(error)
        }
    }

    removeTenantFromApartment = async (data: RemoveTenantFromApartment) => {
        console.log(data)
        try {
            const response = await axios.patch(`${API_URL}/PropertyInventory/remove-tenant`, data)
            if(response.status === 200) {
                return handleSuccessResponse(response)
            }
        } catch (error) {
            console.log(error)
            return handleErrorResponse(error)
        }
    }

}

export const propertyInventoryService = new PropertyInventoryService();